import { call, put, takeLatest } from "redux-saga/effects"
import axios from "axios"
import { push } from "connected-react-router"

import { GET_TEMPLATE_WATCHER, UPLOAD_TEMPLATE_WATCHER } from "./constants"

import {
  getTemplateSuccess,
  getTemplateFailed,
  uploadTemplateSuccess,
  uploadTemplateFailed,
} from "./actions"
import { LOCAL_TOKEN } from "../../utils/storage"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageDestroy() {
  message.destroy()
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function donwloadTemplate(url) {
  location.replace(url)
}

function getTemplateApi(isTemplate) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees/teamleader/export/xlsx?template=true`,
  })
}

function getTemplateApiProgress() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees/teamleader/export/xlsx/progress?template=true`,
    validateStatus: (status) => true, // I'm always returning true,
  })
}

function uploadTemplate(payload) {
  return axios.request({
    method: "post",
    url: `${process.env.API_URL}employees/teamleader/import/xlsx/`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: payload,
  })
}

function uploadTemplateProgress(payload) {
  return axios.request({
    method: "get",
    url: `${process.env.API_URL}employees/teamleader/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
    validateStatus: (status) => true, // I'm always returning true,
  })
}

export function* getTemplateSaga(action) {
  try {
    yield call(messageProgress, "Descargando plantilla")
    yield call(getTemplateApi, action.payload)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 2000))
      data = yield call(getTemplateApiProgress)
      if (data.status === 200) {
        break
      }
    }
    yield call(donwloadTemplate, data.data.data.result[0].url)
    yield call(messageDestroy)
    returnMessage(data)
    yield put(getTemplateSuccess())
  } catch (e) {
    yield call(messageDestroy)
    returnMessage(e)
    yield put(getTemplateFailed())
  }
}

export function* uploadTemplateSaga(action) {
  try {
    yield call(messageProgress, "Cargando archivo")
    yield call(uploadTemplate, action.payload)

    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(uploadTemplateProgress)
      if (data.status === 200) {
        yield put(uploadTemplateSuccess(data.data))
        yield call(messageDestroy)
        returnMessage(data)
        yield put(push("/leaders/import/summary"))
        break
      }
      if (data.status === 500) {
        yield call(messageDestroy)
        message.error(data.data.data.error, 5)
        yield put(uploadTemplateFailed())
        break
      }
    }
  } catch (e) {
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar archivo")
    yield put(uploadTemplateFailed())
  }
}

// Individual exports for testing
export default function* leadersImportSaga() {
  yield takeLatest(GET_TEMPLATE_WATCHER, getTemplateSaga)
  yield takeLatest(UPLOAD_TEMPLATE_WATCHER, uploadTemplateSaga)
}
